import React, { useMemo } from 'react';
import { useTheme } from '@mui/material';
import Dialog, { DialogProps } from '../common/components/dialog/Dialog';
import { SocialGuideContent, SocialGuides } from '../constant/socialGuides';
import LabelIcon from '../common/components/label-icon/LabelIcon';
import { px2rem } from '../core';
import { boxCss } from '../common/style';

export interface LinkGuideModalProps extends DialogProps {
    type: string | null;
}

const LinkGuideModal: React.FC<LinkGuideModalProps> = ({ type, ...props }) => {
    const theme = useTheme();
    const guideData: SocialGuideContent = useMemo<SocialGuideContent>(() => {
        let res: SocialGuideContent = {
            title: '',
        };
        if (type && typeof SocialGuides[type] != 'undefined') {
            res = SocialGuides[type];
        }
        return res;
    }, [type]);
    const typeUpper = type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
    return (
        <>
            <Dialog {...props}>
                <div
                    css={{
                        padding: `0rem ${px2rem(16)} ${px2rem(40)} ${px2rem(16)}`,
                    }}
                >
                    <div
                        css={{
                            marginBottom: px2rem(16),
                        }}
                    >
                        <div
                            css={{
                                height: px2rem(44),
                                width: px2rem(44),
                                backgroundColor: 'black',
                                color: 'white',
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: px2rem(30),
                                alignItems: 'center',
                            }}
                        >
                            {type && <LabelIcon type={'solid'} color={'white'} size={30} icon={typeUpper} />}
                        </div>
                    </div>
                    <h4
                        css={{
                            fontSize: px2rem(20),
                            marginBottom: px2rem(6),
                            fontWeight: 'bold',
                        }}
                    >
                        {guideData.title}
                    </h4>
                    <p
                        css={{
                            color: theme.palette.primary80,
                            fontSize: '14px',
                        }}
                    >
                        {guideData.description}
                    </p>
                </div>
                <div
                    css={{
                        padding: px2rem(20),
                        backgroundColor: '#F8F8F9',
                        color: theme.palette.primary80,
                    }}
                >
                    {guideData.items &&
                        guideData.items.length &&
                        guideData.items.map((content: string, index) => {
                            return (
                                <div
                                    key={index}
                                    css={[
                                        boxCss(theme),
                                        {
                                            position: 'relative',
                                            color: 'white',
                                            borderRadius: px2rem(10),
                                            padding: px2rem(16),
                                            marginBottom: px2rem(30),
                                            backgroundColor: 'white',
                                        },
                                    ]}
                                >
                                    <div
                                        css={[
                                            boxCss(theme),
                                            {
                                                borderRadius: '100%',
                                                position: 'absolute',
                                                left: px2rem(10),
                                                backgroundColor: 'white',
                                                fontSize: px2rem(10),
                                                padding: `${px2rem(4)} ${px2rem(10)}`,
                                                top: px2rem(-12),
                                                color: theme.palette.primary.main,
                                            },
                                        ]}
                                    >
                                        {index + 1}
                                    </div>
                                    <div
                                        css={{ color: theme.palette.primary80, fontSize: '14px' }}
                                        dangerouslySetInnerHTML={{ __html: content }}
                                    />
                                </div>
                            );
                        })}
                </div>
                <div
                    css={{
                        padding: `${px2rem(30)} ${px2rem(16)}`,
                        paddingBottom: px2rem(60),
                    }}
                >
                    <div
                        css={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: px2rem(10),
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="20" rx="10" fill="#30B9BC" />
                            <path
                                d="M7.34849 9.99984L9.24243 12.0832L13.0303 7.9165"
                                stroke="white"
                                strokeWidth="1.53846"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <div
                        css={{
                            padding: `0 ${px2rem(10)}`,
                            fontWeight: 'bold',
                            textAlign: 'center',
                            fontSize: '14px',
                        }}
                    >
                        {guideData.endNote}
                    </div>
                </div>
            </Dialog>
        </>
    );
};
export default LinkGuideModal;
